<template>
  <div>
    <guest :pageType="2" user_type="2"> </guest> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import guest from '../../tongyong/guest.vue';
 
export default {

  components: {
    guest: guest 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
